<template>
    <Toast />
    <ConfirmPopup></ConfirmPopup>
    <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-3" style="margin-top: 1%;">
            <span class="p-float-label">
                <Dropdown v-model="approval_item" :options="approval_options" optionLabel="name" :loading="loader"
                    @change="show_reason" />
                <label for="Approve_Status">Approve Status</label>
            </span>
        </div>
        <div class="field col-12 md:col-3" style="margin-top: 1%;" v-if="reject_flag == 1">
            <span class="p-float-label">
                <Dropdown v-model="reject_item" :options="reject_options" optionLabel="name" :loading="loader" />
                <label for="reject_item">Reject Reason</label>
            </span>
        </div>
    </div>
    <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12" style="margin-top: 1%;">
            <span class="p-float-label">
                <Textarea inputId="remark" rows="5" cols="30" v-model="remark"></Textarea>
                <label for="Approve_remark">Remark</label>
            </span>
        </div>
    </div>
    <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12" style="margin-top: 1%;">
            <Button type="button" label="Submit" icon="pi pi-check" @click="confirm($event)" />
        </div>
    </div>
    <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12" style="margin-top: 1%;">
            <DataTable ref="home_dt" :value="approval_history" class="p-datatable-sm" :rows="5" :loading="loading"
                style="font-size: 10px" :paginator="true" dataKey="sr_no" :rowHover="true" showGridlines>
                <template #header>
                    <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                        <h5 class="m-0">Approval History</h5>
                    </div>
                    <div style="text-align: right; font-weight: bold">
                        <span>Total :</span>{{ approval_history.length }}
                    </div>
                </template>
                <template #empty> No Record found. </template>
                <Column field="status" header="Status" sortable style="min-width: 5rem">
                    <template #body="{ data }">
                        <span>{{ data.status }}</span>
                    </template>
                </Column>
                <Column field="RejectRemarks" header="Remark" sortable style="min-width: 10rem">
                    <template #body="{ data }">
                        <span>{{ data.RejectRemarks }}</span>
                    </template>
                </Column>
                <Column field="rejectreason" header="Reject Reason" sortable style="min-width: 10rem">
                    <template #body="{ data }">
                        <span>{{ data.rejectreason }}</span>
                    </template>
                </Column>
                <Column field="created_at" header="Date" sortable style="min-width: 5rem">
                    <template #body="{ data }">
                        <span>{{ dateFormatDMY(data.created_at) }}</span>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
</template>
<script>
import apis from "@/apis";
import ProductService from "../../service/ProductService";
export default {
    data() {
        return {
            loading:false,
            approval_history: [],
            loader: false,
            productService: null,
            approval_item: null,
            approval_options: null,
            reject_item: null,
            reject_options: null,
            reject_flag: 0,
            remark: "",
            log_data: [],
        };
    },
    props: ["product", "process_type_id", "RoleID", "table", "current_ApplicationStatus", "url"],
    async mounted() {
        this.reset_details();
        this.get_reject_reason();
        this.approval_dropdown();
        this.approval_log_history();
    },
    async created() {
        this.productService = new ProductService();
    },
    methods:
    {
        async reset_details() {
            this.approval_item = null;
            this.approval_options = null;
            this.reject_item = null;
            this.reject_options = null;
            this.remark = "";
            this.log_data = [];
            this.approval_history = [];
        },
        async approval_dropdown() {
            this.loader = true;
            var data = {
                "table": this.table,
                "current_ApplicationStatus": this.current_ApplicationStatus,
                "RoleID": this.RoleID,
                "process_type_id": this.process_type_id
            }
            var promise = apis.approval_dropdown(data);
            promise.then((response) => {
                this.loader = false;
                var approval_list = response.data.data;
                this.approval_options = [];
                for (let x = 0; x < approval_list.length; x++) {
                    this.approval_options.push({ name: approval_list[x].status, code: approval_list[x].S1, IsReject: approval_list[x].IsReject })
                }
            });
        },
        async approval_log_history() {
            this.approval_history = [];
            var data = {
                table: this.table,
                process_type_id: this.process_type_id,
                application_id: this.product._id
            };
            this.loading=true;
            var promise = apis.approval_log_history(data);
            promise.then((response) => {
                this.loading=false;
                this.approval_history = response.data.data;
            });
        },
        confirm(event) {
            if (this.approval_item=='' || this.approval_item==null || this.approval_item==undefined || !this.approval_item) 
            {
                this.$toast.add({ severity: 'error', summary: 'Error !!!', detail: 'Please Select Approval Status', life: 3000 });
                return false;
            }
            if (this.remark=='' || this.remark==null || this.remark==undefined || !this.remark) 
            {
                this.$toast.add({ severity: 'error', summary: 'Error !!!', detail: 'Please Enter Remark', life: 3000 });
                return false;
            }
            

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure you want to proceed?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.save_data();
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'cancelled', detail: 'You have cancelled approval', life: 3000 });
                }
            });
        },
        async save_data() {
            //insert entry in log table
            this.add_log();
            this.$emit('on_submit', this.remark, this.approval_item.code);
        },
        async add_log() {
            var data = {
                "StatusID": this.approval_item.code,
                "RejectReasonID": this.reject_item ? this.reject_item.code : '',
                "RejectRemarks": this.remark,
                "process_type_id": this.process_type_id,
                "application_id": this.product._id,
                "created_by": localStorage.getItem("id"),
            }
            var promise = apis.add_approval_log(data);
            promise.then((response) => { });
        },
        dateFormatDMY(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == "NaN-NaN-NaN") {
                    return postdate;
                } else {
                    let date = ("0" + inputDate.getDate()).slice(-2);
                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                    // current year
                    let year = inputDate.getFullYear();
                    let hours = ("0" + inputDate.getHours()).slice(-2);
                    let minutes = ("0" + inputDate.getMinutes()).slice(-2);
                    let seconds = ("0" + inputDate.getSeconds()).slice(-2);
                    if (date.toString() == "aN") {
                        return postdate;
                    } else {
                        return date + "/" + month + "/" + year + " " + hours + ":" + minutes;
                    }
                }
            } else {
                return "";
            }
        },
        get_reject_reason() {
            this.reject_item = null;
            var data = {
                process_type_id: this.process_type_id,
            };
            var promise = apis.reject_reason(data);
            promise.then((response) => {
                var reject_list = response.data.data;
                this.reject_options = [];
                for (let x = 0; x < reject_list.length; x++) {
                    this.reject_options.push({ name: reject_list[x].reason, code: reject_list[x]._id })
                }
            });
        },
        show_reason() {
            this.reject_item = null;
            if (this.approval_item.IsReject == 1) {
                this.reject_flag = 1;
            } else {
                this.reject_flag = 0;
            }
        }
    },
    components: {
    }
};
</script>